import React from 'react';
import { motion } from 'framer-motion';

const Hero = ({ onOpenQuote }) => {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-primary/60"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-20">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-accent font-medium tracking-[0.2em] uppercase mb-4 text-sm md:text-base"
        >
          Elevating Spaces, Inspiring Lives
        </motion.p>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl md:text-6xl lg:text-7xl text-white font-serif font-bold leading-tight mb-6"
        >
          Crafting Your Dream <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-accent-light">Interior Experience</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-gray-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto font-light"
        >
          We blend aesthetics with functionality to create spaces that resonate with your unique lifestyle and personality.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="#portfolio"
            className="bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-sm transition-all duration-300 uppercase tracking-wider text-sm font-medium"
          >
            View Our Work
          </a>
          <button
            onClick={onOpenQuote}
            className="bg-transparent border border-white hover:bg-white hover:text-primary text-white px-8 py-4 rounded-sm transition-all duration-300 uppercase tracking-wider text-sm font-medium"
          >
            Consult With Us
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;